import { api } from 'API'
import { CheckoutSessionResponse } from 'types/billing'

export interface IBillingSummary {
  billingModel: string
  playerSeats: { total: number; paid: number; free: number; overdue: number }
  coachSeats: { used: number; free: number; paid: number }
  trialDaysRemaining: number
  estimatedYearlyCost: number
}

export interface IConnectStatus {
  hasConnectAccount: boolean
  accountId?: string
  chargesEnabled: boolean
  payoutsEnabled: boolean
}

export async function createCheckoutSession(
  membershipId: number,
  successUrl: string,
  cancelUrl: string
): Promise<CheckoutSessionResponse> {
  const response = await api.post('/billing/checkout-session', {
    membershipId,
    successUrl,
    cancelUrl
  })
  return response.data as CheckoutSessionResponse
}

export async function createBillingPortalSession(
  returnUrl: string
): Promise<{ url: string }> {
  const response = await api.post('/billing/portal-session', { returnUrl })
  return response.data as { url: string }
}

export async function getBillingSummary(): Promise<IBillingSummary> {
  const response = await api.get('/billing/summary')
  return response.data as IBillingSummary
}

export async function getConnectStatus(): Promise<IConnectStatus> {
  const response = await api.get('/billing/connect-status')
  return response.data as IConnectStatus
}

export async function createConnectOnboard(
  refreshUrl: string,
  returnUrl: string
): Promise<{ url: string }> {
  const response = await api.post('/billing/connect-onboard', { refreshUrl, returnUrl })
  return response.data as { url: string }
}
